import { post, fetch } from 'shared/api_utils';

export const postNewsletter = (email) => post('/newsletter', {
    email
});

